import React, { SVGProps } from 'react';

export const EyeV2Icon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 26,
  height = 21,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 26 21"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.8915 9.975C23.2664 3.81938 18.3281 0 13 0C7.67186 0 2.73358 3.81938 0.108492 9.975C0.036935 10.1406 0 10.3193 0 10.5C0 10.6807 0.036935 10.8594 0.108492 11.025C2.73358 17.1806 7.67186 21 13 21C18.3281 21 23.2664 17.1806 25.8915 11.025C25.9631 10.8594 26 10.6807 26 10.5C26 10.3193 25.9631 10.1406 25.8915 9.975ZM13 18.375C8.88044 18.375 4.98179 15.3694 2.73358 10.5C4.98179 5.63062 8.88044 2.625 13 2.625C17.1196 2.625 21.0182 5.63062 23.2664 10.5C21.0182 15.3694 17.1196 18.375 13 18.375ZM13 5.25C11.9719 5.25 10.9669 5.55791 10.112 6.13478C9.2572 6.71166 8.59094 7.5316 8.1975 8.49091C7.80406 9.45022 7.70112 10.5058 7.90169 11.5242C8.10227 12.5426 8.59735 13.4781 9.32433 14.2123C10.0513 14.9465 10.9775 15.4466 11.9859 15.6491C12.9942 15.8517 14.0394 15.7477 14.9893 15.3504C15.9391 14.953 16.751 14.2801 17.3221 13.4167C17.8933 12.5534 18.1982 11.5384 18.1982 10.5C18.1982 9.10761 17.6505 7.77225 16.6757 6.78769C15.7008 5.80312 14.3786 5.25 13 5.25ZM13 13.125C12.4859 13.125 11.9834 12.971 11.556 12.6826C11.1286 12.3942 10.7955 11.9842 10.5988 11.5045C10.402 11.0249 10.3506 10.4971 10.4508 9.98789C10.5511 9.47869 10.7987 9.01096 11.1622 8.64385C11.5257 8.27673 11.9888 8.02672 12.4929 7.92544C12.9971 7.82415 13.5197 7.87614 13.9946 8.07482C14.4696 8.2735 14.8755 8.60995 15.1611 9.04163C15.4467 9.47331 15.5991 9.98082 15.5991 10.5C15.5991 11.1962 15.3253 11.8639 14.8378 12.3562C14.3504 12.8484 13.6893 13.125 13 13.125Z"
        fill="white"
      />
    </svg>
  );
};
